import React from "react";

import { useLocalization } from "@fluent/react";
import { Row } from "@narmi/design_system";

import { formatReceiptAmount, formatReceiptDate } from "../../format";

import styles from "./ReceiptDetailsDrawer.module.scss";

interface ReceiptDetailsCardProps {
  merchant: string | null;
  transactionDate: string | null;
  amount: string | null;
  uploadedBy?: string | null;
  uploadedAt?: string | null;
  approvedBy?: string | null;
}

const DetailRow = ({ label, value }: { label: string; value: string }) => (
  <Row justifyContent="space-between" alignItems="center">
    <Row.Item>
      <span className="fontColor--secondary">{label}</span>
    </Row.Item>
    <Row.Item shrink>
      <span className={value ? "fontColor--primary" : "fontColor--hint"}>
        {value || "—"}
      </span>
    </Row.Item>
  </Row>
);

const ReceiptDetailsCard = ({
  merchant,
  transactionDate,
  amount,
  uploadedBy,
  uploadedAt,
  approvedBy,
}: ReceiptDetailsCardProps) => {
  const { l10n } = useLocalization();

  return (
    <div
      className={`${styles.card} border--all rounded--all--m padding--all--m`}
      data-testid="receipt-details-card"
    >
      <p className="nds-typescale--upper fontColor--secondary fontWeight--bold fontSize--xs margin--bottom--s">
        {l10n.getString("receipts-drawer-receipt-details")}
      </p>
      <div>
        <DetailRow
          label={l10n.getString("receipts-drawer-merchant")}
          value={merchant ?? ""}
        />
      </div>
      <div className="margin--top--xs">
        <DetailRow
          label={l10n.getString("receipts-drawer-date")}
          value={formatReceiptDate(transactionDate)}
        />
      </div>
      <div className="margin--top--xs">
        <DetailRow
          label={l10n.getString("receipts-drawer-amount")}
          value={formatReceiptAmount(amount)}
        />
      </div>
      {uploadedBy && (
        <div className="margin--top--xs">
          <DetailRow
            label={l10n.getString("receipts-drawer-uploaded-by")}
            value={uploadedBy}
          />
        </div>
      )}
      {uploadedAt && (
        <div className="margin--top--xs">
          <DetailRow
            label={l10n.getString("receipts-drawer-uploaded")}
            value={formatReceiptDate(uploadedAt)}
          />
        </div>
      )}
      {approvedBy && (
        <div className="margin--top--xs">
          <DetailRow
            label={l10n.getString("receipts-drawer-approved-by")}
            value={approvedBy}
          />
        </div>
      )}
    </div>
  );
};

export default ReceiptDetailsCard;
